import React, { useState } from "react";
import instance from "../../ApiInstance/Inetrceptor";
import "./login.css";
import {
  TextField,
  Button,
  Typography,
  Grid,
  InputAdornment,
  IconButton,
  Alert,
  CircularProgress,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import { Link, useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import { baseUrl, LOCAL_STORAGE_KEY,User_Info } from "../../Config";
import axios from "axios";
import CryptoJS from 'crypto-js';
import Captcha from "./Captcha";

const LoginPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [usernamePlaceholder, setUsernamePlaceholder] = useState("Username");
  const [showEmailIcon, setShowEmailIcon] = useState(false);
  const [passwordPlaceholder, setPasswordPlaceholder] = useState("Password");
  const [showPasswordIcon, setShowPasswordIcon] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaValid, setCaptchaValid] = useState(false);
  const [captchaText, setCaptchaText] = useState(""); 

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };
  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };
  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };
  const handleUsernameFocus = () => {
    setUsernamePlaceholder("Enter your email address");
    setShowEmailIcon(true);
  };
  const handleUsernameBlur = (event) => {
    if (event.target.value.trim() === "") {
      setUsernamePlaceholder("Username");
      setShowEmailIcon(false);
    }
  };
  const handlePasswordFocus = () => {
    setPasswordPlaceholder("Enter your Password");
    setShowPasswordIcon(true);
  };

  const handlePasswordBlur = (event) => {
    if (event.target.value.trim() === "") {
      setPasswordPlaceholder("Password");
      setShowPasswordIcon(false);
    }
  };
  const handleCloseErrorcode = () => {
    setError(""); 
  };
  const handleCaptchaChange = (event) => {
    setCaptchaInput(event.target.value);
  };
  const GetSaltValue = async() =>{
   try{
    const end_point = `${baseUrl}/api/v1/User/GetSalt?username=${username}`;
   let res =  await axios.get(end_point)
   if(res?.data?.Success === true) {
    setError("");
    return res.data.Value;
   }
   else{
    setError(res?.data?.ResultMessage)
    setTimeout(() => {
      handleCloseErrorcode();
    }, 5000);
    return null;
   }
}
catch (error) {
  console.log("error",error);
   
}
  }
  const GetpermissionValue = async(Role) =>{
    console.log("role",Role);
    try{
     const end_point = `${baseUrl}/api/v1/User/GetNavigations?role=${Role}`;
    let res = await instance.get(end_point)
    if(res?.data?.Success === true) {
     setError("");
     const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(res.data.Value), 'encryptedValue').toString();
     localStorage.setItem('encryptedValue', encryptedValue);
     navigate("/");
     return res.data.Value;
     
    }
    else{
     setError(res?.data?.ResultMessage)
     setTimeout(() => {
       handleCloseErrorcode();
     }, 5000);
     return null;
    }
 }
 catch (error) {
   console.log("error",error);
    
 }
   }
  const onLogin = async () => {
    let SaltKey = await GetSaltValue();
    if(SaltKey === null){
      return;
    }
      setLoading(true);
      const enteredEmail = username.trim();
      const enteredPassword = password.trim();
        const plaintextPassword = enteredPassword;
        const randomSalt = SaltKey;
        const hashedPassword = CryptoJS.SHA256(plaintextPassword + randomSalt).toString(CryptoJS.enc.Hex);
        const params = new URLSearchParams();
        params.append("password", hashedPassword);
        params.append("username", enteredEmail);
        params.append("grant_type", "password");
        const endpoint = `${baseUrl}/Token`;
        axios
          .post(endpoint, params)
          .then((res) => {
            if (res?.data?.access_token) {
              console.log(res?.data, "res?.data?.access_token");
              let Role = res?.data?.role
              setError("");
              localStorage.setItem(
                LOCAL_STORAGE_KEY,
                JSON.stringify(res?.data.access_token)
              );
              localStorage.setItem(
                User_Info,
                JSON.stringify(res?.data)
              );
              GetpermissionValue(Role);
            }
          })
          .catch((error) => {
            if (error?.response?.data?.error === "invalid_grant") {
              setError("Please enter a valid  password.");
              setTimeout(() => {
                handleCloseErrorcode();
              }, 5000);
              console.error(error);
            } else {
              setError("Something went wrong");
              setTimeout(() => {
                handleCloseErrorcode();
              }, 5000);
              console.error(error);
            }
          }).finally(()=>{
             setLoading(false);
          });
  };
  const handleFormKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleLogin(); 
    }
  };
  const combiningCharsRegex = /[\u0300-\u036F]/g;

  const handleLogin = () => {
    const enteredEmail = username.trim();
    const enteredPassword = password.trim();
  
    if (!enteredEmail || !enteredPassword) {
      setError("Please enter a valid username and password.");
      setTimeout(() => {
        handleCloseErrorcode();
      }, 5000);
      return;
    }
  
    console.log(captchaInput, captchaText, "captchaText");
  
    // Remove combining characters from both captcha inputs
    const cleanCaptchaInput = removeCombiningCharacters(captchaInput);
    const cleanCaptchaText = removeCombiningCharacters(captchaText);
  
    // Check if cleaned inputs match exactly (case-sensitive and alphanumeric strictness)
    if (cleanCaptchaInput === cleanCaptchaText) {
      setCaptchaValid(true);
      onLogin();
    } else {
      setCaptchaValid(false);
      setError("Invalid CAPTCHA. Please try again.");
      setTimeout(() => {
        handleCloseErrorcode();
      }, 5000);
    }
  };
  

  
  

    // Remove combining characters
    const removeCombiningCharacters = (text) => {
      return text.normalize("NFD").replace(combiningCharsRegex, '');
    };
    
    
  
  // const handleLogin = () => {
  //    const enteredEmail = username.trim();
  //    const enteredPassword = password.trim();

  //   // if (!enteredEmail && !enteredPassword) {
  //   //   setError("Please enter a valid username and password.");
  //   //   setTimeout(() => {
  //   //     handleCloseErrorcode();
  //   //   }, 5000);
  //   // }
  //   //  else {
  //   //   onLogin();
  //   // }
  //   if (!enteredEmail && !enteredPassword) {
  //     setError("Please enter a valid username and password.");
  //     setTimeout(() => {
  //       handleCloseErrorcode();
  //     }, 5000);
  //   } else {
  //     console.log(captchaInput, captchaText,"captchaText");
  //     if (captchaInput.toLowerCase() == captchaText.toLowerCase()) {
  //       setCaptchaValid(true);
  //       onLogin();
  //     } else {
  //       setCaptchaValid(false);
  //       setError("Invalid CAPTCHA. Please try again.");
  //       setTimeout(() => {
  //         handleCloseErrorcode();
  //       }, 5000);
  //     }
  //   }
  // };
  return (
    <Grid container sx={{ height: "100%" }}>
      <Grid
        item
        lg={7}
        md={6}
        xs={12}
        sm={12}
        sx={{
          backgroundImage: "url(assets/Images/LoginBackground.svg)",
          backgroundSize: "cover",
          borderBottomRightRadius: "20px",
          borderTopRightRadius: "20px",
        }}
      ></Grid>
      <Grid item lg={5} md={6} xs={12} sm={12}>
        <div className="Logo-style">
          <img
            src="assets/Images/Logo.svg"
            alt="Logo"
            style={{
              width: "40%",
              height: "15%",
            }}
          />
          <Typography variant="h7" component="h1" className="font-color mb-2">
            Sign in
          </Typography>

          {error && (
            <Alert
              variant="outlined"
              severity="error"
              icon={<CancelIcon onClick={handleCloseErrorcode} />}
              className="errorAlert mt-4"
            >
              {error}
            </Alert>
          )}
          <TextField
             
            id="username"
            name="username"
            label={<>Username<span style={{color:"var(--color-miscellaneous-7)"}}>*</span></>}
            className="mb-4"
            fullWidth
            autoComplete="family-name"
            variant="standard"
            onFocus={handleUsernameFocus}
            onKeyDown={handleFormKeyDown}
            onBlur={(event) => handleUsernameBlur(event)}
            onChange={handleUsernameChange}
            InputProps={{
              startAdornment: showEmailIcon && (
                <InputAdornment position="start">
                  <IconButton>
                    <EmailIcon />
                  </IconButton>
                </InputAdornment>
              ),
              placeholder: usernamePlaceholder,
            }}
            InputLabelProps={{
              style: { color: "black" },
            }}
          />

          <TextField
            id="password"
            name="password"
            label={<>Password<span style={{color:"var(--color-miscellaneous-7)"}}>*</span></>}
            fullWidth
            autoComplete="current-password"
            variant="standard"
            type={showPassword ? "text" : "password"}
            onFocus={handlePasswordFocus}
            onBlur={(event) => handlePasswordBlur(event)}
            onKeyDown={handleFormKeyDown}
            onChange={handlePasswordChange}
            onCopy={(e) => e.preventDefault()}
            // onPaste={(e) => e.preventDefault()} 
            InputProps={{
              startAdornment: showPasswordIcon && (
                <InputAdornment position="start">
                  <IconButton>
                    <LockIcon />
                  </IconButton>
                </InputAdornment>
              ),
              placeholder: passwordPlaceholder,
              endAdornment: (
                <InputAdornment
                          position="end"
                          style={{ position: "absolute", right: 20 }}>
                  <IconButton onClick={handleTogglePassword}>
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            InputLabelProps={{
              style: { color: "black" },
            }}
            style={{
              msReveal: 'none',
            }}
          />
           {/* CAPTCHA Component */}
           <Captcha
            style={{ marginTop: '20px' }} 
            onChange={handleCaptchaChange}
            captchaText={captchaText}
            setCaptchaText={setCaptchaText}
          />

          <Grid container>
            {/* <Grid item lg={6}>
              <FormControlLabel
                control={<Checkbox className="font-color"  checked={rememberMe}
                onChange={handleRememberMeChange}/>}
                label="Remember me"
              />
            </Grid> */}
            <Grid item lg={12} textAlign="right" style={{ paddingTop: "2rem" }}>
              <Link
                to="/forgot-password"
                variant="body2"
                className="font-color">
                Forgot password?
              </Link>
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            onClick={handleLogin}
            className={"button-style"}
            color="secondary"
            disabled={loading} 
            sx={{
              backgroundColor: loading ? 'var(--color-secondary) !important' : 'button-style',
            }}>
            Login &nbsp;{loading &&<CircularProgress color="inherit" size={24}/> }
          </Button>
        </div>
      </Grid>
     
    </Grid>
  );
};
export default LoginPage;
